<template>
  <StandardFlexBox
    direction="column"
    height="270px"
    >
    <!-- Legende -->
    <StandardFlexBox width="100%" height="30px">
      <StandardDataField
        width="20%"
        flat="true"
        :readonly="true"
        />
        <div class="ml-3 mr-2"/>
      <StandardDataField
        width="20%"
        :value="$t('Project.Workpackage.Costs.WorkBenchEditor.Labour')"
        icon="accessibility"
        :text_color="work_package.textcolor"
        :readonly="true"
        />
      <div class="ml-2 mr-2">+</div>
      <StandardDataField
        width="20%"
        :value="$t('Project.Workpackage.Costs.WorkBenchEditor.Material')"
        icon="view_module"
        :text_color="work_package.textcolor"
        :readonly="true"
        />
      <div class="ml-2 mr-2">=</div>
      <StandardDataField
        width="20%"
        value="     +"
        icon="accessibility"
        :text_color="work_package.textcolor"
        append_icon="view_module"
        :readonly="true"
        />
    </StandardFlexBox>
    <StandardFlexBox width="100%">
      <StandardDataField
        width="20%"
        value="budget"
        icon="account_balance_wallet"
        :text_color="work_package.textcolor"
        :readonly="true"
        />
        <div class="ml-3 mr-2"/>
      <StandardDataField
        width="20%"
        :text_color="work_package.textcolor"
        :value="work_package.costs_budget_labour"
        :type="'number'"
        :readonly="true"
        />
        <div class="ml-2 mr-2">+</div>
      <StandardDataField
          width="20%"
          :text_color="work_package.textcolor"
          :value="work_package.costs_budget_material"
          :type="'number'"
          :readonly="true"
          />
        <div class="ml-2 mr-2">=</div>
      <StandardDataField
        width="20%"
        :text_color="work_package.textcolor"
        :value="parseInt(work_package.costs_budget_labour) + parseInt(work_package.costs_budget_material)"
        :readonly="true"
        />
    </StandardFlexBox>
  </StandardFlexBox>
</template>
<script>
  import { WorkBenchWorkPackageInfoBoxMixin} from '@/mixins/WorkBenchWorkPackageInfoBox.mixin.js'
  export default {
    props: [],
    mixins: [
      WorkBenchWorkPackageInfoBoxMixin,
    ],
    data: () => ({
    }),
  }
</script>
<style>
  .class {

  }
</style>
